import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsSkillsPage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="skills"
    />
  );
}
